<template>
  <v-select
    v-model="type"
    v-bind="$attrs"
    v-on="$listeners"
    item-text="title"
    item-value="id"
    :label="$t('finance.expenceType')"
    :loading="loading"
    :items="items"
  />
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      default: '',
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    type: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('change', v);
      },
    },
    items() {
      return this.$store.state['company-expenses'].expenseTypesList;
    },
  },
  methods: {
    async fetchTypesList() {
      this.loading = true;
      await this.$store.dispatch('company-expenses/fetchExpenseTypes');
      this.loading = false;
    },
  },
  created() {
    this.fetchTypesList();
  },
};
</script>

<style></style>
